import { get, writable } from 'svelte/store'
import { fingerprint } from './index'
import * as Fingerprint from '@fingerprint/agent'
import { log, captureMessage } from '$lib/utilities/errorTrackingTools'
import { PUBLIC_FPJS_TOKEN, PUBLIC_FPJS_URL, PUBLIC_FPJS_TARGET } from '$env/static/public'
import type { FingerprintResult } from '$lib/types'
import SiruAxios from '$lib/SiruAxios'

export const createFingerprint = () => {
    const initialState: FingerprintResult = null

    const { subscribe, set } = writable(initialState)

    return {
        subscribe,
        set,
        get: async () => {
            log({ message: 'Start loading the FpJS client instance (FP.start)', category: 'fingerprint' })

            // If 25 seconds after, we still do not have a fingerprint, capture error message for our trackers
            const fpFailureTimeout = setTimeout(() => {
                if (get(fingerprint) === null) {
                    captureMessage('Fingerprint failed on timeout')
                }
            }, 25_000)

            const fpClient = Fingerprint.start({
                apiKey: PUBLIC_FPJS_TOKEN,
                endpoints: PUBLIC_FPJS_URL,
                region: 'eu',
            })

            log({
                message:
                    'FpJS client instance has been loaded (fp.start finished). Starting the FpJS fingerprint creation.',
                category: 'fingerprint',
            })

            const requestMetadata = {
                requestType: 'mysiru',
                target: PUBLIC_FPJS_TARGET,
            }

            const response = await fpClient.get({ timeout: 20000, tag: requestMetadata })

            log({ message: 'FpJS Fingerprint creation has ended.', category: 'fingerprint', data: response })

            if (response.visitor_id) {
                SiruAxios.defaults.headers.common['x-fpjs-request-id'] = response.event_id

                clearTimeout(fpFailureTimeout)

                return set(response)
            } else {
                throw new Error(`Error: Missing visitor_id in response: ${JSON.stringify(response)}`)
            }
        },
    }
}
